"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethod = exports.protobufPackage = void 0;
/* eslint-disable */
exports.protobufPackage = 'qover.dojo.payment.v1';
var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["PAYMENT_METHOD_UNSPECIFIED"] = "PAYMENT_METHOD_UNSPECIFIED";
    PaymentMethod["PAYMENT_METHOD_BANCONTACT"] = "PAYMENT_METHOD_BANCONTACT";
    PaymentMethod["PAYMENT_METHOD_SEPADD"] = "PAYMENT_METHOD_SEPADD";
    PaymentMethod["PAYMENT_METHOD_CREDITLINE"] = "PAYMENT_METHOD_CREDITLINE";
    PaymentMethod["PAYMENT_METHOD_CREDITCARD"] = "PAYMENT_METHOD_CREDITCARD";
    PaymentMethod["PAYMENT_METHOD_IDEAL"] = "PAYMENT_METHOD_IDEAL";
    PaymentMethod["PAYMENT_METHOD_SOFORT"] = "PAYMENT_METHOD_SOFORT";
    PaymentMethod["PAYMENT_METHOD_GIROPAY"] = "PAYMENT_METHOD_GIROPAY";
})(PaymentMethod = exports.PaymentMethod || (exports.PaymentMethod = {}));
